var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0069 6.00004C12.7442 5.99775 12.4912 6.09876 12.3023 6.28129L7.29331 11.2915C7.1055 11.4795 7 11.7343 7 12C7 12.2657 7.1055 12.5205 7.29331 12.7085L12.3023 17.7187C12.4912 17.9012 12.7442 18.0022 13.0069 18C13.2696 17.9977 13.5208 17.8923 13.7066 17.7065C13.8923 17.5207 13.9977 17.2694 14 17.0067C14.0022 16.7439 13.9013 16.4908 13.7188 16.3018L9.41811 12L10.4199 10.9979L13.7188 7.69819C13.9013 7.5092 14.0022 7.25608 14 6.99335C13.9977 6.73061 13.8923 6.47928 13.7066 6.29349C13.5208 6.10771 13.2696 6.00232 13.0069 6.00004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSm);
export default __webpack_public_path__ + "static/media/left-sm.afc798b831b8946d10ae6a51946a4ec3.svg";
export { ForwardRef as ReactComponent };